import { usingGet } from '@ocean/api'

export const getCompanySpecificTrainingDetails = (
  companySpecificTrainingId: Guid,
  resultId?: Guid
) => {
  const baseUrl = `CompanyTrainings/details/${companySpecificTrainingId}`
  const url = resultId ? `${baseUrl}/${resultId}` : baseUrl
  return usingGet(url, { useProxy: true })
}
